import { useState } from 'react';
import { BLOCKS, INITIAL_SORTED_VIOLATIONS } from '@constants';

export default function useScannerWizardState() {
	const [pageURL, setPageURL] = useState(null);
	const [pageHTML, setPageHTML] = useState(null);
	const [pageDocument, setPageDocument] = useState(null);

	const [results, setResults] = useState();
	const [sortedViolations, setSortedViolations] = useState(
		INITIAL_SORTED_VIOLATIONS,
	);
	const [openedBlock, setOpenedBlock] = useState(BLOCKS.main);
	const [loading, setLoading] = useState(true);
	const [proxyError, setProxyError] = useState(false);
	const [isError, setIsError] = useState(false);
	const [colorContrastData, setColorContrastData] = useState({});
	const [openIndex, setOpenIndex] = useState(0);
	const [violation, setViolation] = useState(null);

	return {
		// state values
		pageURL,
		pageHTML,
		pageDocument,
		results,
		sortedViolations,
		openedBlock,
		loading,
		proxyError,
		isError,
		colorContrastData,
		openIndex,
		violation,
		// setters
		setPageURL,
		setPageHTML,
		setPageDocument,
		setResults,
		setSortedViolations,
		setOpenedBlock,
		setLoading,
		setProxyError,
		setIsError,
		setColorContrastData,
		setOpenIndex,
		setViolation,
	};
}
